import './style.css';
import NodeComponent from "../node";
import {SettingNodeIcon} from "./icons";

export function CodehookActionNode({ id, data }) {
    return (
        <NodeComponent title="Codehook Action" id={id} data={data} nodeTypeIcon={<SettingNodeIcon/>}>
            <div></div>
        </NodeComponent>
    );
}

